export function isTurnBlockedForEighteenHoles(
  turnBlockedType: string | null | undefined,
  originalBlockedType?: string | null,
): boolean {
  if (!turnBlockedType) {
    return false;
  }

  if (turnBlockedType === "blocked" || turnBlockedType === "shotgun_blocked" || turnBlockedType === "shotgun_disabled") {
    return true;
  }

  if (turnBlockedType === "shotgun_crossover") {
    return originalBlockedType !== "shotgun";
  }

  return false;
}
